import { z } from 'zod';
import { phoneSchema } from './auth.js';

export const updateUserProfileSchema = z.object({
  name: z.string().min(2).max(120).optional(),
  phone: phoneSchema.optional(),
  avatarUrl: z.string().url().optional(),
  document: z.string().optional(),
  documentType: z.enum(['cpf', 'cnpj']).optional(),
});

export type UpdateUserProfileInput = z.infer<typeof updateUserProfileSchema>;
